import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi2";
import { staticUrl } from "../../config";
import OptimisedImage from "../../views/components/OptimisedImage";



const VerticalSlider = (props) => {
  const sliderRef = useRef(null);

  let slidesToShow = 2;

  if (props.images.length > 2) {
    slidesToShow = 3;
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    vertical: true,
    arrows: false,
  };

  // Handle image click event
  const handleImageClick = (imageUrl, imageDesc) => {
    props.onImageClick(imageUrl, imageDesc);
  };

  useEffect(() => {
    const _images = props.images.map((item, index) => ({
      thumbnail: `${staticUrl}/img/media/products/product_${item}.jpg`,
      thumbnailFallback: `${staticUrl}/img/media/products/thumbnail_${item}.jpg`,
      url: `${staticUrl}/img/media/products/product_${item}.jpg`,
      description: props.descriptions[index],
    }));
    setImages(_images);
  }, [props.images]);

  const [images, setImages] = useState([]);

  return (
    <div className="flex flex-col items-center justify-center">
      {/* Up arrow */}
      <button
        aria-label="Previous image"
        className="text-kb-400/30 hover:text-kb-400 text-2xl xl:text-5xl focus:outline-none"
        onClick={() => sliderRef.current.slickPrev()}
      >
        <HiChevronLeft className="rotate-90" aria-hidden="true" />
      </button>

      <div className="w-[180px] px-4">
        <Slider ref={sliderRef} {...settings}>
          {images.map((image, index) => (
            <div
              key={index}
              className="px-4 py-2 cursor-pointer outline-none"
              onClick={() => handleImageClick(image.url, image.description)}
            >
              <OptimisedImage
                src={image.thumbnail}
                fallbackSrc={image.thumbnailFallback}
                height="600"
                width="600"
                alt={`${image.description}`}
                style={{ boxShadow: "0 0 18px rgba(112, 128, 144, 0.25)" }}
              />
            </div>
          ))}
        </Slider>
      </div>

      {/* Down arrow */}
      <button
        aria-label="Next image"
        className="text-kb-400/30 hover:text-kb-400 text-2xl xl:text-5xl focus:outline-none"
        onClick={() => sliderRef.current.slickNext()}
      >
        <HiChevronRight className="rotate-90" aria-hidden="true" />
      </button>
    </div>
  );
};

export default VerticalSlider;
